// image-carousel.component.ts
import { SpinnerService } from '../../spinner.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { Component, Input, ElementRef, ViewChild, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { environment } from '@app/../environments/environment';


import { FormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import * as common from '@app/shared/_models/common';
import { ImageViewerDialogComponent } from '../image-viewer-dialog/image-viewer-dialog.component';
import { AttachService } from '@app/shared/attach/attach.service';
import { Attach } from '@app/shared/_models/common';
import { AlertService } from '@app/shared/alert.service';
import { MatIconModule ,} from '@angular/material/icon';
import { icons_doc, IconDocKey } from '@app/shared/attach/icon_doc';
import { isSealedAttach } from '@app/shared/attach/attach-seal';
import { canOpenInline } from '@app/shared/attach/attach-inline';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';


@Component({
    selector: 'app-image-carousel',
		standalone: true,
    templateUrl: './image-carousel.component.html',
    styleUrls: ['./image-carousel.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, MatIconModule, MatProgressSpinnerModule]
})
export class ImageCarouselComponent {
  @Input() attachs : common.Attach[] =[]  ;
  @Input() canEdit: boolean = true;
  // @Input() title = 'Documents joints';
  @Output() imagesChanged = new EventEmitter<common.Attach[]>();
  
  @ViewChild('track') trackRef!: ElementRef<HTMLDivElement>;
  
  isAtStart = true;
  isAtEnd = false;
  icons_doc: Record<string, SafeHtml> = {};
  private videoExtensions = ['mp4', 'mkv', 'avi', 'mov', 'wmv', 'flv', 'webm', 'm4v', 'mpeg', 'mpg', '3gp', 'ogv'];
  // URL de miniature en échec (blob vide ou non décodable) : `.no-thumb` sur la zone image, l'écran hôte en fait ce qu'il veut.
  // Clé = l'URL, pas la pièce : l'échec du `src` vide d'avant l'arrivée du blob ne masque pas le blob, que l'hôte cache ou non l'image.
  private brokenThumbs = new Set<string>();

  private scrollAmount = 400;

  constructor(private dialog: MatDialog , private attachService:AttachService, private router: Router, private alertService: AlertService, private sanitizer: DomSanitizer, private http: HttpClient ) {
  Object.entries(icons_doc).forEach(([key, svg]) => {
    this.icons_doc[key] = this.sanitizer.bypassSecurityTrustHtml(svg);
  });
  }

  ngOnInit(){
   console.log('this.attachs_images',this.attachs); 
  }

  // Scellée : ni renommage, ni image par défaut, ni suppression (server.common.attach-sceau) ; téléchargement et rang restent ouverts.
  isSealed(attach: common.Attach): boolean {
    return isSealedAttach(attach);
  }

  onImageClick(imageId: number) {
    console.log('Image cliquée:', imageId);
    
    // Trouver l'image correspondante
    const attach = this.attachs.find(img => img.id === imageId);
    if (!attach) {
      console.error('Image non trouvée pour l\'id:', imageId);
      return;
    }
    
    if(attach.contenttype && ( attach.contenttype.startsWith("image") || attach.contenttype.startsWith("video/youtube") ) ){
            // Ouvrir le dialogue avec l'image
      this.dialog.open(ImageViewerDialogComponent, {
        width: '90%',
        maxWidth: '1200px',
        maxHeight: '90vh',
        data: { attach: attach },
        panelClass: 'image-viewer-dialog-panel'
      });
    } else if (attach.contenttype && attach.contenttype.startsWith("video/youtube") ) {


    } else if (canOpenInline(attach.contenttype)) {
      this.attachService.openInNewTab(imageId);
    } else {
      this.download(this.attachs.indexOf(attach), attach); // html, svg… : ouverts en URL blob, ils s'exécuteraient dans l'origine du front
    }
  }

  // ─── DÉPLACER UNE PIÈCE D'UN CRAN, SANS RECHARGER LA PAGE ─────────────────────────────
  //
  // Jusqu'au 2026-09-14 le déplacement se terminait par un window.location.reload() — un vrai
  // F5 pour changer une séquence, et dans une fenêtre modale la fermeture de la fiche avec sa
  // saisie. Désormais : OPTIMISTE, puis COMPARÉ.
  //   1. la pièce change de place à l'écran tout de suite, en rejouant le geste du serveur
  //      (elle prend le rang de sa voisine, la voisine recule ou avance d'un cran) ;
  //   2. le serveur (POST /attachaction) fait de même en base et RÉPOND AVEC LA SÉQUENCE
  //      RÉSULTANTE — les (id, seq) actifs de l'objet, hors texte ;
  //   3. l'écran s'aligne sur cette réponse : si elle coïncide avec ce qu'il a fait, rien ne
  //      bouge ; sinon (rangs non contigus, pièce sans rang, écriture concurrente) la liste se
  //      retrie dessus. Ce n'est qu'en cas de PANNE — erreur HTTP, ou refus métier en 200 —
  //      que la liste est relue depuis le serveur (/docsbyobjectid), et à défaut remise dans
  //      l'état d'avant le geste. Un serveur d'avant, qui ne rend pas de séquence, est cru sur
  //      parole : l'état optimiste reste.
  // Le tableau est modifié EN PLACE (splice, sort) : c'est l'instance que le parent tient, et
  // le gabarit itère dessus — l'ordre du tableau EST l'ordre affiché.
  moveSequence(attach : common.Attach, action: 1|-1) {
    const i = this.attachs.indexOf(attach);
    const j = i + action;
    if (i < 0 || j < 0 || j >= this.attachs.length) return;
    const neighbour = this.attachs[j];
    const before = this.attachs.map((a) => ({ a, seq: a.seq }));   // pour revenir en arrière
    const posted = { objecttyp: attach.objecttyp, objectid: attach.objectid, attachid: attach.id, seq: attach.seq, action };

    // Le geste du serveur, joué ici. Une voisine sans rang : on ne peut rien rejouer, le
    // serveur ne trouvera pas de voisine non plus — la réponse remettra les choses en place.
    const nseq = neighbour.seq;
    if (nseq !== undefined && nseq !== null) { neighbour.seq = nseq - action; attach.seq = nseq; }
    this.attachs.splice(i, 1);
    this.attachs.splice(j, 0, attach);

    this.attachService.postAttachAction(posted).subscribe({
      next: (response: any) => {
        // Un refus métier arrive en HTTP 200 avec success:false (cf. POST /event) : c'est une panne.
        if (response && response.success === false) {
          this.alertService.error('Déplacement refusé : ' + (response.message ?? ''));
          this.resyncSequence(before);
          return;
        }
        const sequence = response?.data?.sequence;
        if (Array.isArray(sequence)) this.applySequence(sequence);
        this.imagesChanged.emit(this.attachs);
      },
      error: (error) => {
        const errorMessage = error.error?.message || error.message || 'Erreur lors du déplacement';
        this.alertService.error(`Impossible de déplacer la pièce : ${errorMessage}`);
        this.resyncSequence(before);
      }
    });
  }

  /** Aligne le tableau sur une séquence (id, seq) rendue par le serveur : les rangs sont
   *  recopiés sur les pièces connues, puis le tableau est retrié en place — par rang, les
   *  pièces sans rang à la fin, puis par id. Une pièce que le serveur ne cite pas garde son rang. */
  private applySequence(sequence: { id: number; seq: number | null }[]): void {
    const seqById = new Map<number, number | null>(sequence.map((s) => [+s.id, s.seq]));
    for (const a of this.attachs) if (a.id && seqById.has(a.id)) a.seq = seqById.get(a.id) ?? undefined;
    this.attachs.sort((x, y) => ((x.seq ?? Number.MAX_SAFE_INTEGER) - (y.seq ?? Number.MAX_SAFE_INTEGER)) || ((x.id ?? 0) - (y.id ?? 0)));
  }

  /** La panne : on relit les rangs depuis le serveur (/docsbyobjectid — il ne filtre pas sur
   *  objecttyp, on le fait ici) ; si cette lecture échoue aussi, on remet l'ordre et les rangs
   *  d'avant le geste. Jamais de rechargement de page. */
  private resyncSequence(before: { a: common.Attach; seq: number | undefined }[]): void {
    const ref = this.attachs[0];
    const restore = () => {
      before.forEach(({ a, seq }) => { a.seq = seq; });
      this.attachs.splice(0, this.attachs.length, ...before.map((b) => b.a));
    };
    if (!ref?.objectid) { restore(); return; }
    this.http.get<any[]>(environment.server_url + '/docsbyobjectid/' + ref.objectid).pipe(take(1)).subscribe({
      next: (rows: any[]) => {
        const mine = (rows ?? []).filter((r) => +r.objecttyp === +ref.objecttyp && !!r.contenttype && !r.contenttype.startsWith('text/'));
        if (!mine.length) { restore(); return; }
        this.applySequence(mine.map((r) => ({ id: +r.id, seq: r.seq ?? null })));
      },
      error: () => restore(),
    });
  }

  /** Le nom sans son extension — ce que le champ montre et ce qu'on y tape. */
  baseOf(name: string | undefined | null): string {
    const n = name ?? '';
    const dot = n.lastIndexOf('.');
    return dot > 0 ? n.slice(0, dot) : n;
  }

  /** L'extension seule, vide s'il n'y en a pas : « photo » n'a pas d'extension « photo », et
   *  « nom. » (point fantôme d'un ancien renommage) n'en a pas non plus. */
  extOf(name: string | undefined | null): string {
    const n = name ?? '';
    const dot = n.lastIndexOf('.');
    return dot > 0 ? n.slice(dot + 1) : '';
  }

  /** Renommer : ÉCRIT AU DÉPART DU CHAMP (blur), par l'event 602 ATTACH_RENAME — sans passer
   *  par « Enregistrer ». L'extension n'est pas saisissable : elle est remise derrière le nom.
   *  Pas de point quand il n'y a pas d'extension : une pièce nommée « . » (renommée depuis un
   *  champ vide, du temps où /docsbyobjectid ne rendait pas les noms) finissait en « nom. ». */
  updateName(index: number, event: Event , ext : string) {
    const input = event.target as HTMLInputElement;
    const newName = input.value.trim();
    
    if (this.attachs[index] && this.isSealed(this.attachs[index])) return;   // le serveur refuserait
    if (this.attachs[index]) {
      this.attachs[index].name = ext ? newName + '.' + ext : newName;
      this.attachService.renameAttach$(this.attachs[index]).subscribe({});
    }
  }

  isDefaultImage(attach: common.Attach): boolean {
    const flags = attach.data?.['flags'];
    return Array.isArray(flags) && flags.includes('is_default_image');
  }

  setAsDefaultImage(index: number, new_default_image: Attach,  event: Event) {
    if (this.isSealed(new_default_image)) return;                            // le serveur refuserait
    const isChecked = (event.target as HTMLInputElement).checked;
    console.log('this.attach_image',this.attachs);
    
    // Sauvegarder l'état initial avant les modifications
    const oldAttachs = this.attachs.map(attach => ({  ...attach,  data: attach.data ? { ...attach.data, flags: attach.data['flags'] ? [...attach.data['flags']] : [] } : undefined}));
    
    let old_default_image 
    // Décocher toutes les autres images par défaut et recuperer l ancienne default img
    this.attachs.forEach((attach, i) => {
      if ( attach.data && attach.data['flags'] &&  Array.isArray( attach.data['flags']  )  && attach.data['flags'].includes('is_default_image')  ) {
        attach.data['flags'] = attach.data['flags'].filter(item => item !==  'is_default_image')
        old_default_image = attach;
      }
    });
    if (isChecked) {
      if (new_default_image.data && Array.isArray(new_default_image.data['flags'])) {
        new_default_image.data['flags'].push('is_default_image');
      } else {    // Créer un objet data avec un champ flags qui est un tableau
        new_default_image.data = {flags: ['is_default_image'] };
      }
    }
    this.attachService.setDefaultImage$(new_default_image ,  old_default_image , isChecked ).subscribe({
      next: () => {this.imagesChanged.emit(this.attachs);     }, // Pour l'instant personne ne l ecoute Succès : émettre l'événement de changement
      error: (error) => {
        // Restaurer les anciennes valeurs
        this.attachs = oldAttachs;
        
        // Afficher un message d'erreur à l'utilisateur
        const errorMessage = error.error?.message || error.message || 'Erreur lors de la modification de l\'image par défaut';
        this.alertService.error(`Impossible de modifier l'image par défaut : ${errorMessage}`);
        
        console.error('Erreur lors de la modification de l\'image par défaut:', error);
      }
  });

  }
download(index: number, attach_image: Attach) {
  this.attachService.loadImage$(attach_image.id ?? 0).subscribe({
    next: (blob: Blob) => {
      const forceDownloadBlob = new Blob([blob], { type: 'application/octet-stream' });
      const objectUrl = window.URL.createObjectURL(forceDownloadBlob);
      const link = document.createElement('a');
      link.href = objectUrl;
      link.download = attach_image.name || `document-${attach_image.id}.pdf`;
      link.style.display = 'none';
      link.target = '_self';
      document.body.appendChild(link);
      link.click();
      // Délai avant nettoyage
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(objectUrl);
      }, 200);
    },
    error: (err) => console.error('Erreur de téléchargement', err)
  });
}

  deleteImage(index: number , attach_image: Attach ) {
    if (this.isSealed(attach_image)) {                                       // le serveur refuserait
      this.alertService.warn('Document scellé : il ne peut être ni modifié ni supprimé.');
      return;
    }
    if (confirm('Êtes-vous sûr de vouloir supprimer cette image ?')) {
      // Sauvegarder l'image et son index avant suppression
      const imageToDelete = { ...attach_image };
      const originalIndex = index;
      
      // Supprimer l'image du tableau localement (optimiste)
      this.attachs.splice(index, 1);
      // Mettre à jour les séquences après suppression absurde
      // this.attachs.forEach((img, i) => { img.seq = i + 1; });
      
      // Appeler le backend pour supprimer l'image
      this.attachService.suppressImage(attach_image).subscribe({
        next: () => {this.imagesChanged.emit(this.attachs);     }, // Pour l'instant personne ne l ecoute Succès : émettre l'événement de changement
     
        error: (error) => { this.attachs.splice(originalIndex, 0, imageToDelete);    // Erreur : restaurer l'image dans le tableau
          this.attachs.forEach((img, i) => {  img.seq = i + 1;   }); // Remettre à jour les séquences avec l'image restaurée
          
          // Afficher un message d'erreur à l'utilisateur
          const errorMessage = error.error?.message || error.message || 'Erreur lors de la suppression de l\'image';
          this.alertService.error(`Impossible de supprimer l'image : ${errorMessage}`);
          
          console.error('Erreur lors de la suppression de l\'image:', error);
        }
      });
    }
  }


  getIcon(attach: Attach): SafeHtml | null {
  const ext = attach.name?.split('.')?.pop()?.toLowerCase() ?? '';
  if (this.videoExtensions.includes(ext)) {
    return this.icons_doc['video'];
  } else if ( attach.contenttype && attach.contenttype.includes("youtube")){
    return this.icons_doc['youtube'];
  }
  return this.icons_doc[ext] ?? null;
}

  isThumbBroken(attach: Attach): boolean {
    return this.brokenThumbs.has(attach.thumbnailLocalUrl ?? '');
  }

  onThumbError(attach: Attach): void {
    this.brokenThumbs.add(attach.thumbnailLocalUrl ?? '');
  }

// showPdf(doc_id:number) {
//     this.attachService.loadImage$( doc_id).pipe(   // Get doc by fse_doc.id w/ content
//       tap((docs:dao.FseDoc[]) => {  // TODO add FseDOc type
//         const doc = docs[0]; 
//         console.log("[showPdf] doc: ", JSON.stringify(doc, null, 2));
        
//         if (!doc.content) {
//           this.errormsg = "Le contenu du document est vide ou indisponible.";
//           return;
//         }
                
//         const byteArray = doc.content; // This is the array of numbers
  
//         // Convert to Uint8Array
//         const pdfData = new Uint8Array(byteArray);
  
//         // Create a Blob with PDF MIME type
//         const blob = new Blob([pdfData], { type: 'application/pdf' });
  
//         // Create a URL for the Blob
//         const url = window.URL.createObjectURL(blob);
  
//         // Option 1: Open in a new tab
//         window.open(url);         
//       }),
//       ).subscribe({ 
//         next: (docs: any[]) => {},
//         error: (error) => {
//           console.error('Request failed', error);
//           this.errormsg = error instanceof Error ? error.message : JSON.stringify(error);
//         }             
//     }); 
//   }


}